module.exports = __webpack_public_path__ + "img/新产品.png";